module.exports = __webpack_public_path__ + "img/email-confirmation-successful.da5ee344.svg";